export const ONBOARDINGS_ID = 'onboardings';

export const ONBOARDING_PANEL_ID = 'onboarding-panel';

/** `onboarding_id` value of the tab that shows live data across all onboardings. */
export const CURRENT_ONBOARDING_ID = 'current';

export const CURRENT_TAB_ID = 'onboarding-tab-current';

export const getSubsectionAnchorId = (subsection: string) => `onboarding-${subsection}`;
